import {userGeolocation} from "../userGeolocation";
import addFavorite from "../addFavorite";
import {copyToClipboard} from "../copyToClipboard";
import {FastOrder} from "../fast-order";
import {PriceRequest} from "../price-request";
import {alert} from "../alert";
import zipperModal from "../zipperModal";
import {ArrivalRequest} from "../arrival-request";
import {sizeTable} from "../size-table";
import {menu} from "../menu";
import {GoodCard} from "../good-card";
import ShowMoreContent from "../show-more-content";
import {stickyHeader} from "../sticky-header";
import {ChangeProductSize} from "../change-product-size";
import {ProductGallery} from "../product-gallery";
import {AddCart} from "../cart/addCart";
import {productSwipers} from "../product-swipers";
import {ProductSummary} from "../product-summary";
import {Modals} from "../modals";

userGeolocation();

menu();

addFavorite({activeClass: `add-favorite--pressed`});

copyToClipboard();

const fastOrderForm = document.querySelector(`.js-fast-order-form`);
if (fastOrderForm) {
  new FastOrder(fastOrderForm).init();
}

const openPriceRequestElement = document.querySelector(`.js-price-request-open`);
if (openPriceRequestElement) {
  new PriceRequest().init();
}

new ArrivalRequest().init();

sizeTable();

alert();

zipperModal();

new AddCart();

if (document.querySelector(`.js-good-cards`)) {
  new GoodCard(document.querySelector(`.js-good-cards`));
}

new ShowMoreContent({
  btnSelector: ".js-show-more-btn",
  contentSelector: ".js-show-more-content",
});

stickyHeader();

new ChangeProductSize();
new ProductGallery();
productSwipers();
new ProductSummary();
new Modals();
